import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import Loader from '@/components/ui/Loader'
import { fetcher } from 'api/swr'
import useSWR from 'swr'
import { DLC } from './types'

interface SelectDlcProps {
  tid: string
  update: (value: string) => void
  value?: string
}

export const SelectDlc = ({ tid, update, value }: SelectDlcProps) => {
  const { data: dlcs, isLoading } = useSWR<DLC[]>(['/dlcs', { tid }], fetcher)

  if (isLoading) return <Loader />
  if (!dlcs) return <div>{tid}</div>

  return (
    <Select onValueChange={update} defaultValue={value} value={value}>
      <SelectTrigger className="w-auto max-w-xs">
        <SelectValue placeholder={"Select DLC"} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Select Dlc</SelectLabel>
          <SelectItem value={tid}>{tid} - default</SelectItem>
          {dlcs.map((dlc) => (
            <SelectItem key={dlc.id} value={dlc.id}>
              {dlc.id} - {dlc.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
